export const lightGrey = 'rgba(0, 0, 0, 0.6);'
export const border = '#132802'
export const olive = '#676556'
